export const passkeyOfferKey = (userId: string) => `passkeyOfferDismissed:${userId}`;
export function shouldShowPasskeyButton(args: { hasWebAuthn: boolean; available: boolean }): boolean {
  return args.hasWebAuthn && args.available;
}
export function hasWebAuthn(): boolean {
  return typeof PublicKeyCredential !== 'undefined';
}

const CEREMONY_ABORTED = 'ERROR_CEREMONY_ABORTED';

function isCeremonyAbort(value: unknown): boolean {
  if (typeof value !== 'object' || value === null) return false;
  const record = value as { name?: unknown; code?: unknown; message?: unknown };
  if (record.name === 'AbortError') return true;
  if (record.code === CEREMONY_ABORTED) return true;
  return typeof record.message === 'string' && record.message.includes(CEREMONY_ABORTED);
}

export function isPasskeyCeremonyCancelled(error: unknown): boolean {
  if (isCeremonyAbort(error)) return true;
  if (typeof error !== 'object' || error === null || !('cause' in error)) return false;
  return isCeremonyAbort(error.cause);
}
